import React from 'react';
import { HeaderContainer, Title, Icon } from './styledComponents';


const Header = () => {
  return (
    <HeaderContainer>
      <Icon />
      <Title>Cover Letter Generator</Title>
    </HeaderContainer>
  );
};

export default Header;
